/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Render_Audio_Failed_Retry_ToastInputs */

const en_render_audio_failed_retry_toast = /** @type {(inputs: Render_Audio_Failed_Retry_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Converting text to speech audio failed. Please Retry:${i?.error}`)
};

const fr_render_audio_failed_retry_toast = /** @type {(inputs: Render_Audio_Failed_Retry_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec de la conversion du texte en audio. Veuillez reessayer :${i?.error}`)
};

const de_render_audio_failed_retry_toast = /** @type {(inputs: Render_Audio_Failed_Retry_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die Umwandlung von Text in Sprache ist fehlgeschlagen. Bitte versuchen Sie es erneut:${i?.error}`)
};

const it_render_audio_failed_retry_toast = /** @type {(inputs: Render_Audio_Failed_Retry_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conversione del testo in audio vocale non riuscita. Riprova: ${i?.error}`)
};

const ru_render_audio_failed_retry_toast = /** @type {(inputs: Render_Audio_Failed_Retry_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось преобразовать текст в аудиозапись. Пожалуйста, повторите попытку:${i?.error}`)
};

const es_render_audio_failed_retry_toast = /** @type {(inputs: Render_Audio_Failed_Retry_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al convertir texto a audio de voz. Vuelva a intentarlo: ${i?.error}`)
};

const zh_cn2_render_audio_failed_retry_toast = /** @type {(inputs: Render_Audio_Failed_Retry_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`文本转语音失败。请重试：${i?.error}`)
};

const ja_render_audio_failed_retry_toast = /** @type {(inputs: Render_Audio_Failed_Retry_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`テキストを音声に変換できませんでした。再試行してください:${i?.error}`)
};

const hi_render_audio_failed_retry_toast = /** @type {(inputs: Render_Audio_Failed_Retry_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`टेक्स्ट को ऑडियो स्पीच में परिवर्तित करने में विफलता मिली। कृपया पुनः प्रयास करें:${i?.error}`)
};

const pt_pt2_render_audio_failed_retry_toast = /** @type {(inputs: Render_Audio_Failed_Retry_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A conversão de texto em áudio de fala falhou. Tente novamente: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Converting text to speech audio failed. Please Retry:{error}" |
*
* @param {Render_Audio_Failed_Retry_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const render_audio_failed_retry_toast = /** @type {((inputs: Render_Audio_Failed_Retry_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Render_Audio_Failed_Retry_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_render_audio_failed_retry_toast(inputs)
	if (locale === "de") return de_render_audio_failed_retry_toast(inputs)
	if (locale === "it") return it_render_audio_failed_retry_toast(inputs)
	if (locale === "ru") return ru_render_audio_failed_retry_toast(inputs)
	if (locale === "es") return es_render_audio_failed_retry_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_render_audio_failed_retry_toast(inputs)
	if (locale === "ja") return ja_render_audio_failed_retry_toast(inputs)
	if (locale === "hi") return hi_render_audio_failed_retry_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_render_audio_failed_retry_toast(inputs)
	return en_render_audio_failed_retry_toast(inputs)
});